export default __webpack_public_path__ + "static/media/shadow-type-3.b69ce2eb.svg";